import { rateLimitingEnabled } from '@/utils';

export default {
  computed: {
    defaultCustomQuizImageAttachmentId() {
      return this.$store.getters['app/defaultCustomQuizImageAttachmentId'];
    },
    defaultCustomQuizImageAttachment() {
      return this.$store.getters['attachments/get'][this.defaultCustomQuizImageAttachmentId];
    },
    defaultImageIcon() {
      return this.defaultCustomQuizImageAttachment?.url || '';
    },
    routePrefix() {
      return (this.$route.name.includes('scenario')) ? 'scenario' : 'quizzes';
    },
  },
  watch: {
    defaultCustomQuizImageAttachmentId() {
      this.fetchDefaultImage();
    },
  },
  mounted() {
    this.fetchDefaultImage();
  },
  methods: {
    fetchDefaultImage() {
      if (this.defaultCustomQuizImageAttachmentId) {
        this.$store.dispatch('attachments/fetch', { ids: [this.defaultCustomQuizImageAttachmentId] });
      }
    },
    restartQuiz(category, query = null) {
      this.$analytics.events.restartedQuiz(this.$store, category);
      this.$store.dispatch('quizzes/resetQuiz', category.id).then(() => {
        this.$router.push({ name: `${this.routePrefix}#flashcard`, params: { categoryId: category.id }, query: query || this.currentQuery });
      });
    },
    startQuiz(category, query = null) {
      this.$analytics.events.startedQuiz(this.$store, category);
      let params = {
        number: 0,
        categoryStatusId: this.$store.getters['categoryStatuses/inProgressStatus'].id,
        categoryId: category.id,
        mobileCreatedAt: Date.now(),
        rateLimited: rateLimitingEnabled({
          apptimize: this.$apptimize,
          store: this.$store,
          analytics: this.$analytics,
        }),
      };

      this.$store.dispatch('categoryStates/sendCategoryState', params);
      this.$router.push({ name: `${this.routePrefix}#flashcard`, params: { categoryId: category.id }, query: query || this.currentQuery });
    },
    continueQuiz(category, query = null) {
      this.$analytics.events.continuedQuiz(this.$store, category);
      this.$router.push({ name: `${this.routePrefix}#flashcard`, params: { categoryId: category.id }, query: query || this.currentQuery });
    },
    quizStatus(category) {
      let state = this.$store.getters['categoryStates/categoryStates'][category.id] || {categoryStatusId: this.$store.getters['categoryStatuses/notStartedStatus'].id};
      return this.$store.getters['categoryStatuses/categoryStatuses'].find(cs => cs.id == state.categoryStatusId);
    },
    deleteQuiz(category) {
      if (confirm('Are you sure you want to delete this quiz? This action cannot be undone.')) {
        this.$store.dispatch('quizzes/deleteQuiz', category.id).then(() => {
          this.$notify({
            group: 'notifications',
            title: 'Quiz Deleted',
            text: 'The quiz has been deleted successfully.',
            type: 'success',
          });
        }).catch(error => {
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: 'Failed to delete the quiz. Please try again.',
            type: 'error',
          });
        });
      }
    },
  },
};
